// Import React
import React, { useState } from "react";
import PropTypes from "prop-types";

// Components
import ToggleWrapper from "../benchmarking-toggles/BenchmarkingAnonymousToggle.components";

// Functions
import { comma } from "../../helpers/common.functions";

// Style
import "./BenchmarkCollectionsMiniTable.css";

BenchmarkCollectionsMiniTable.propTypes = {
  selectedCollection: PropTypes.object,
  setSelectedCollection: PropTypes.func,
  benchmarkCollections: PropTypes.object,
  user: PropTypes.object,
};

export default function BenchmarkCollectionsMiniTable(props) {
  const { selectedCollection, setSelectedCollection } = props;
  const { benchmarkCollections } = props;
  const { user } = props;

  const [isLocked, setIsLocked] = useState(false);

  const displayMiniTable = [];

  selectedCollection.benchmarkComparisons?.forEach((benchmark, i) => {
    displayMiniTable.push(
      <div key={benchmark.id + "0"} className="grid-item">
        {i + 1}
      </div>
    );
    displayMiniTable.push(
      <div key={benchmark.id + "1"} className="grid-item">
        <div className="bcmt-toggle-container">
          <div className="bcmt-toggle-container-name">
            {benchmark.isAnonymous
              ? benchmark.project_name_original
              : benchmark.project_name}
          </div>
          <ToggleWrapper
            key={benchmark.id}
            name={benchmark.project_name_short}
            isAnonymous={benchmark.isAnonymous}
            comparisonId={benchmark.id}
            benchmarkId={selectedCollection.id}
            linkedBenchmarksIds={selectedCollection.linkedBenchmarksIds}
            user={user}
            // Toggle State
            showToggle={true}
            setIsLocked={setIsLocked}
            isLocked={isLocked}
            isRealNameHidden={true}
            // Update Function
            updateState={async () => {
              // Retrieve the collections after the update to refresh the UI
              const benchmarkCollectionsData = await benchmarkCollections.get();
              const updatedSelectedCollection =
                benchmarkCollectionsData.data.find(
                  (c) => c.id === selectedCollection.id
                );
              // Set the selected collection again with the updated values
              setSelectedCollection(updatedSelectedCollection);
              // Update the list of collections as well
              benchmarkCollections.set(benchmarkCollectionsData);
            }}
          />
        </div>
      </div>
    );

    displayMiniTable.push(
      <div key={benchmark.id + "3"} className="grid-item">
        {benchmark.standard}
      </div>
    );
    displayMiniTable.push(
      <div key={benchmark.id + "4"} className="grid-item">
        {benchmark.client}
      </div>
    );
    displayMiniTable.push(
      <div key={benchmark.id + "5"} className="grid-item">
        {benchmark.city}
      </div>
    );
    displayMiniTable.push(
      <div key={benchmark.id + "6"} className="grid-item">
        {comma(benchmark.local_region_area)}
      </div>
    );
    displayMiniTable.push(
      <div key={benchmark.id + "7"} className="grid-item">
        {comma(benchmark.construction_cost)}
      </div>
    );
  });

  return (
    <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
      <div>
        <div className="benchmark-mini-table grid">
          <div className="grid-item">#</div>
          <div className="grid-item">Name</div>
          <div className="grid-item">CBS</div>
          <div className="grid-item">Client</div>
          <div className="grid-item">City</div>
          <div className="grid-item">Local Region Area</div>
          <div className="grid-item">Construction Cost</div>
          {displayMiniTable}
        </div>
      </div>
    </div>
  );
}
